var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    staticClass: "ma-8",
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-btn-toggle', {
    attrs: {
      "borderless": ""
    }
  }, [_c('v-btn', _vm._b({
    attrs: {
      "small": "",
      "text": "",
      "icon": ""
    },
    on: {
      "click": _vm.decreaseZoom
    }
  }, 'v-btn', {
    disabled: _vm.disabled_decrease
  }, false), [_c('v-icon', [_vm._v("mdi-minus")])], 1), _c('v-btn', _vm._b({
    attrs: {
      "small": "",
      "text": "",
      "icon": ""
    },
    on: {
      "click": _vm.increaseZoom
    }
  }, 'v-btn', {
    disabled: _vm.disabled_increase
  }, false), [_c('v-icon', [_vm._v("mdi-plus")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }